<div class="toast" [loopAtom]="statusAtom()">
  <div class="toast-content">
    <loop-icon class="toast-status-icon" [name]="statusIconName()" width="16px" />

    <div class="flex-col toast-text">
      @if (toastSignal().title) {
        <div class="toast-title bold">
          {{ toastSignal().title }}
        </div>
      }
      @if (toastSignal().message) {
        <div class="toast-message text-medium">
          {{ toastSignal().message }}
        </div>
      }
      @if (toastSignal().link; as link) {
        <div>
          <loop-link loopAtom="tertiary" (click)="link.actionFn?.()">
            {{ link.text }}
          </loop-link>
        </div>
      }
    </div>
    @if (toastSignal().isClosable) {
      <a (click)="closed.emit()" class="toast-close-cross"><loop-icon name="xmark" width="8px" /></a>
    }
  </div>
</div>
